import styled from 'react-emotion';
import { Fill } from 'spectacle';

export default styled(Fill)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
